import { gql } from 'urql';

const fundingOptionsQuery = gql`
  query FundingOptions($input: FundingOptionsInput!) {
    fundingOptions(input: $input) {
      ... on FundingOptionsPage {
        title
        options {
          id
          type
          title
          tags {
            id
            tagColor
            text
          }
          clickAnalytics {
            name
            properties {
              key
              value
            }
          }
        }
        skipButton {
          text
          clickAnalytics {
            name
            properties {
              key
              value
            }
          }
        }
      }
      ... on FundingOptionsError {
        code
        message
        errorTitle: title
      }
    }
  }
`;

export default fundingOptionsQuery;
